import { styled } from '../../Styles/stitches.config'

export const StyledLink = styled('a', {
    color: '$primary600',
    fontWeight: 600,
    transition: '$default',

    variants: {
        underline: {
            none: {
                textDecoration: 'none',
            },

            hover: {
                textDecoration: 'none',

                '@canHover': {
                    '&:hover': {
                        textDecoration: 'underline $colors$primary600',
                    },
                },
            },
            always: {
                textDecoration: 'underline $colors$primary400',

                '@canHover': {
                    '&:hover': {
                        textDecoration: 'underline $colors$primary600',
                    },
                },
            },
        },
    },

    defaultVariants: {
        underline: 'always',
    },
})
